<template>
  <div class="articlelist-container">
    <div>
      <a-row>
        <a-col :span="2">
          <bread-crumb />
        </a-col>
        <a-col :span="22">
          <table-search
            :company-data="companyData"
            :company-value="companyValue"
            @onSearch="onSearch"
            @onSearchDoctor="onSearchDoctor"
            @onSearchPromoter="onSearchPromoter"
            @onChangeStatus="onChangeStatus"
            @onChangeType="onChangeType"
            @onChangeCompany="onChangeCompany"
            @onChangeColumns="onChangeColumns"
            @onStartTime="onStartTime"
            @onEndTime="onEndTime"
            @onChangeVideo="onChangeVideo"
            @editAndAdd="editAndAdd"
          />
        </a-col>
      </a-row>
    </div>
    <div class="global-table-container">
      <div class="recommend-btn-container">
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="publishLoading"
          @click="handlePublish"
        >
          发布
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="nopublishLoading"
          @click="handleNopublish"
        >
          取消发布
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="topLoading"
          @click="handleTop"
        >
          置顶
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="notopLoading"
          @click="handleNotop"
        >
          取消置顶
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="recommendLoading"
          @click="handleRecommend"
        >
          推荐
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="norecommendLoading"
          @click="handleNorecommend"
        >
          取消推荐
        </a-button>
        <a-button
          type="danger"
          class="recommend-btn"
          :loading="delLoading"
          @click="handleDelete"
        >
          删除
        </a-button>
        <span
          v-show="isShowError"
          class="errorMsg"
        >请至少选择一项</span>
      </div>

      <a-table
        :scroll="{ x: 1400 }"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        :row-selection="{
          selectedRowKeys,
          onChange:onchangeCheck,
        }"
        @change="changePage"
      >
        <template
          slot="list_order"
          slot-scope="text, record"
        >
          <editable-cell
            :text="text"
            @change="onCellChange(record.id, 'list_order', $event)"
          />
        </template>
        <template
          slot="admin_type"
          slot-scope="text, record"
        >
          {{ record.admin_type===1?'是':'否' }}
        </template>
        <template
          slot="video"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="handleVideo(record)"
          ><a-icon type="video-camera" /></a>
        </template>
        <template
          slot="status"
          slot-scope="text, record"
        >
          {{ record.data.is_top===1?'置顶':'未置顶' }} |
          {{ record.data.status===1?'发布':'未发布' }} |
          {{ record.data.recommended===1?'推荐':'未推荐' }}
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
          <a-divider
            v-if="record.admin_type===1"
            type="vertical"
          />
          <a
            v-if="record.admin_type===1"
            href="javascript:;"
            @click="() => handleLookPromoter(record)"
          >查看推广员</a>
        </template>
      </a-table>
    </div>
    <video-modal
      :visible="visible"
      :video-url="videoUrl"
      @onCancel="onCancel"
    />
    <promoter-list
      :data="promoterData"
      :visible="visiblePromoter"
      @onCancel="onCancelPromoter"
    />
  </div>
</template>
<script>
import {columns} from './data/index';
import TableSearch from './components/search';
import VideoModal from './modal/index';
import PromoterList from './modal/promoterList';
export default {
  components: {TableSearch, VideoModal, PromoterList},
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      videoUrl: '',
      id: '',
      isShowError: false,
      selectedRowKeys: [],
      recommendLoading: false,
      norecommendLoading: false,
      publishLoading: false,
      nopublishLoading: false,
      topLoading: false,
      notopLoading: false,
      delLoading: false,
      keyword: undefined,
      doctor_name: undefined,
      promoter_name: undefined,
      wstatus: '-1',
      polymorphic_type: '0',
      company_id: '0',
      group_id: '0',
      start_time: undefined,
      end_time: undefined,
      admin_type: -1,
      companyData: [{id: 0, name: '所有公司'}],
      companyValue: undefined,
      promoterData: [],
      visiblePromoter: false,
      objectData: {obj_type: '2',
        page: 1,
        pageSize: 10,
        keyword: undefined,
        doctor_name: undefined,
        promoter_name: undefined,
        wstatus: '-1',
        polymorphic_type: '0',
        company_id: '0',
        group_id: '0',
        start_time: undefined,
        end_time: undefined,
        admin_type: -1,
      },
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData(this.objectData);
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/portalPost/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            name: item.name,
            admin_type: item.admin_type,
            admin_name: item.admin_name,
            list_order: item.list_order,
            hits: item.hits,
            likes: item.likes,
            favorites: item.favorites,
            thumbnail_url: item.thumbnail_url,
            update_time: this.$Format(item.update_time),
            create_time: this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 获取企业
    async getCompanyData(url) {
      let result = await this.$http.post(url);
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item)=>{return {name: item.team_name?item.team_name:item.companyInfo.qichacha_name, ...item};});
        this.companyData = [...[{id: 0, name: '所有公司'}], ...data];
      }
    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.objectData.keyword=value;
      this.getTableData(this.objectData);
    },
    // 搜索医生
    onSearchDoctor(value) {
      this.current=1;
      this.objectData.doctor_name=value;
      this.getTableData(this.objectData);
    },
    // 搜索推广员
    onSearchPromoter(value) {
      this.current=1;
      this.objectData.promoter_name=value;
      this.getTableData(this.objectData);
    },
    // 选择状态
    onChangeStatus(value){
      this.current=1;
      console.log('onChangeStatus -> value', value);
      this.objectData.wstatus=value;
      this.getTableData(this.objectData);
    },
    // 选择企业类型
    async onChangeType(value){
      this.current=1;
      console.log('onChangeType -> value', value);

      if(value===0){
        this.companyData=[{id: 0, name: '所有公司'}];
      }else if(value===1){
        this.getCompanyData('/company/getCompanyList');
      }else{
        this.getCompanyData('/ServiceProvider/getCompanyList');
      }
      this.objectData.polymorphic_type=value;
      this.companyValue='';
      this.objectData.company_id='0';
      this.getTableData(this.objectData);
    },
    // 选择公司
    onChangeCompany(value){
      console.log('onChangeCompany -> value', value);
      this.current=1;
      this.objectData.company_id=value;
      this.companyValue=value;
      this.getTableData(this.objectData);
    },
    // 选择栏目
    onChangeColumns(value){
      this.current=1;
      console.log('onChangeColumns -> value', value);
      this.objectData.group_id=value;
      this.getTableData(this.objectData);
    },
    // 选择开始时间
    onStartTime(value){
      this.current=1;
      console.log('onChangeColumns -> value', value);
      this.objectData.start_time=value.format('YYYY-MM-DD HH:mm:ss');
      this.getTableData(this.objectData);
    },
    // 选择结束时间
    onEndTime(value){
      console.log('onChangeColumns -> value', value);
      this.current=1;
      this.objectData.end_time=value.format('YYYY-MM-DD HH:mm:ss');
      this.getTableData(this.objectData);

    },

    // 选择发布者
    onChangeVideo(value){
      console.log('onChangeColumns -> value', value);
      this.current=1;
      this.objectData.admin_type=value;
      this.getTableData(this.objectData);

    },

    // 编辑或新增
    editAndAdd(record) {
      console.log('editAndAdd -> record', record);
      if(record){
        this.data=record;
        this.$router.push({path: '/video/add', query: {id: record.id}});
      }else{
        this.$router.push({path: '/video/add'});
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.hospitalModalForm.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            console.log(values);
            this.btnIsLoading=true;
            let result=await this.$http.post('/Customer/update', {type: this.type, id: this.id, ...values});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData(this.objectData);
            }
          }
        },
      );
    },
    // 查看视频
    handleVideo(record){
      this.visible=true;
      this.videoUrl=record.data.video_url;
    },
    // 取消查看视频
    onCancel() {
      this.visible = false;
    },
    // 查看推广员
    async handleLookPromoter(record){
      this.visiblePromoter=true;
      let result=await this.$http.post('/portalPost/getVideoRelationInfo', {id: record.id});
      if(result.data.status===1){
        this.promoterData=result.data.data;
      }
    },
    // 取消查看推广员
    onCancelPromoter(){
      this.visiblePromoter=false;
    },
    // 删除单个
    async onDelete(record) {
      let result=await this.$http.post('/portalPost/postDel', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData(this.objectData);
      }
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
      this.isShowError=false;
    },
    // 发布
    async handlePublish() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.publishLoading=true;
      let result = await this.$http.post('/portalPost/postStatus', {
        ids: this.selectedRowKeys,
        status: 1,
      });
      this.publishLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(this.objectData);
      }
    },
    // 取消发布
    async handleNopublish() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.nopublishLoading=true;
      let result = await this.$http.post('/portalPost/postStatus', {
        ids: this.selectedRowKeys,
        status: 0,
      });
      this.nopublishLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(this.objectData);
      }
    },
    // 置顶
    async handleTop() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.topLoading=true;
      let result = await this.$http.post('/portalPost/postTop', {
        ids: this.selectedRowKeys,
        is_top: 1,
      });
      this.topLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(this.objectData);
      }
    },
    // 取消置顶
    async handleNotop() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.notopLoading=true;
      let result = await this.$http.post('/portalPost/postTop', {
        ids: this.selectedRowKeys,
        is_top: 0,
      });
      this.notopLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(this.objectData);
      }
    },


    // 推荐
    async handleRecommend() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.recommendLoading=true;
      let result = await this.$http.post('/portalPost/postRecommended', {
        ids: this.selectedRowKeys,
        recommended: 1,
      });
      this.recommendLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(this.objectData);
      }
    },
    // 取消推荐
    async handleNorecommend() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.norecommendLoading=true;
      let result = await this.$http.post('/portalPost/postRecommended', {
        ids: this.selectedRowKeys,
        recommended: 0,
      });
      this.norecommendLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(this.objectData);
      }
    },
    // 批量删除
    async handleDelete() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.delLoading=true;
      let result = await this.$http.post('/portalPost/postDelMore', {
        ids: this.selectedRowKeys,
      });
      this.delLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(this.objectData);
      }
    },
    // 修改排序
    async onCellChange(id, key, value) {
      let result = await this.$http.post('/portalPost/postOrder', {
        id: id,
        list_order: Number(value),
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData(this.objectData);
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({...this.objectData, page: pagination.current});
    },
  },
};
</script>
<style lang="scss" scoped>
.articlelist-container {
  .recommend-btn-container {
    margin-bottom: 10px;
    .recommend-btn {
      margin-right: 10px;
    }
    .errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}
</style>
